import {
    STORE_CUSTOMER_LOAN,
    STORE_BORROWERS,
    STORE_BORROWER,
    REMOVE_BORROWER,
} from '../../constants/loan';

const initialState = {
    customerLoanHistory: {},
    borrowers: [],
    totalOutstanding: 0,
    activeLoans: 0,
    interestEarningCount: 0,
    monthlyInterestIncome: 0,
};

const upsertBorrower = (borrowers, borrower) => {
    const idx = borrowers.findIndex(
        (b) => b.borrowerId === borrower.borrowerId || b.id === borrower.id,
    );
    if (idx === -1) return [borrower, ...borrowers];
    const next = borrowers.slice();
    next[idx] = borrower;
    return next;
};

const recomputeTotals = (borrowers) => {
    let totalOutstanding = 0;
    let activeLoans = 0;
    let interestEarningCount = 0;
    let monthlyInterestIncome = 0;
    borrowers.forEach((b) => {
        const balance = Number(b.balance) || 0;
        if (balance > 0) {
            totalOutstanding += balance;
            activeLoans += 1;
            const interestType = b.interestType || 'none';
            if (interestType === 'fixed' || interestType === 'percentage') {
                interestEarningCount += 1;
                monthlyInterestIncome +=
                    Number(b.monthlyInterestProjected) || 0;
            }
        }
    });
    return {
        totalOutstanding,
        activeLoans,
        interestEarningCount,
        monthlyInterestIncome,
    };
};

export default (state = initialState, action) => {
    switch (action.type) {
        case STORE_CUSTOMER_LOAN:
            return {
                ...state,
                customerLoanHistory: action.loanHistory,
            };

        case STORE_BORROWERS: {
            const borrowers = action.payload?.borrowers || [];
            const computed = recomputeTotals(borrowers);
            return {
                ...state,
                borrowers,
                totalOutstanding:
                    action.payload?.totalOutstanding ?? computed.totalOutstanding,
                activeLoans:
                    action.payload?.activeLoans ?? computed.activeLoans,
                interestEarningCount:
                    action.payload?.interestEarningCount ??
                    computed.interestEarningCount,
                monthlyInterestIncome:
                    action.payload?.monthlyInterestIncome ??
                    computed.monthlyInterestIncome,
            };
        }

        case STORE_BORROWER: {
            const borrowers = upsertBorrower(state.borrowers, action.borrower);
            return { ...state, borrowers, ...recomputeTotals(borrowers) };
        }

        case REMOVE_BORROWER: {
            const borrowers = state.borrowers.filter(
                (b) =>
                    b.borrowerId !== action.borrowerId &&
                    b.id !== action.borrowerId,
            );
            return { ...state, borrowers, ...recomputeTotals(borrowers) };
        }

        default:
            return state;
    }
};
